import React from "react";

const common = {
  width: 22,
  height: 22,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

const GOLD = "#F5B800";

/* Custom line-icons built around the matrix / alignment metaphor. */
const ICONS = {
  compass: (
    <svg {...common}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 3v2M12 19v2M3 12h2M19 12h2" />
      <path d="M15.5 8.5l-2 5-5 2 2-5z" fill={GOLD} stroke="none" />
      <path d="M15.5 8.5l-2 5-5 2 2-5z" />
    </svg>
  ),
  trust: (
    <svg {...common}>
      <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" />
      <path d="M8.5 12.5l2.3 2.3 4.7-5" stroke={GOLD} strokeWidth="1.8" />
    </svg>
  ),
  manager: (
    <svg {...common}>
      <circle cx="12" cy="6.5" r="2.5" />
      <path d="M12 9v4" />
      <path d="M5 20v-1.5a3 3 0 013-3h0M19 20v-1.5a3 3 0 00-3-3h0" />
      <circle cx="6.5" cy="12.5" r="2" />
      <circle cx="17.5" cy="12.5" r="2" />
      <path d="M12 13l-3.5 2M12 13l3.5 2" stroke={GOLD} />
    </svg>
  ),
  satisfaction: (
    <svg {...common}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
      <path d="M3.5 12h17M12 3.5v17" opacity="0.5" />
      <path d="M5 20V10" stroke={GOLD} strokeWidth="2.2" />
      <circle cx="7.5" cy="7.5" r="1.3" fill={GOLD} stroke="none" />
    </svg>
  ),
  contribution: (
    <svg {...common}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
      <path d="M3.5 12h17M12 3.5v17" opacity="0.5" />
      <path d="M4 20h10" stroke={GOLD} strokeWidth="2.2" />
      <circle cx="16.5" cy="16.5" r="1.3" fill={GOLD} stroke="none" />
    </svg>
  ),
  retention: (
    <svg {...common}>
      <path d="M4 19V6a2 2 0 012-2h9l5 5v10a2 2 0 01-2 2H6a2 2 0 01-2-2z" />
      <path d="M15 4v5h5" />
      <path d="M8 14h5M8 17h8" opacity="0.6" />
      <path d="M9 10.5l1.5 1.5L13 9.5" stroke={GOLD} strokeWidth="1.8" />
    </svg>
  ),
  drivers: (
    <svg {...common}>
      <path d="M4 20V4" />
      <path d="M4 20h16" />
      <path d="M7 16l4-5 3 3 5-7" stroke={GOLD} strokeWidth="1.8" />
      <circle cx="19" cy="7" r="1.4" fill={GOLD} stroke="none" />
    </svg>
  ),
  segments: (
    <svg {...common}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
      <path d="M3.5 12h17M12 3.5v17" />
      <rect x="13.5" y="5" width="5.5" height="5.5" rx="1" fill={GOLD} stroke="none" />
      <circle cx="7.5" cy="16.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="16.5" cy="16.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="7.5" cy="7.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  ),
};

export const InsightIcon = ({ name }) => ICONS[name] || ICONS.segments;

export const CheckGlyph = ({ className }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M5 12.5l4.2 4.2L19 7" />
  </svg>
);
